import { Box, Divider, Stack, Typography } from '@mui/material'
import React from 'react'
import { InputLabelStyled, ParentSelectBox } from './PresentingComplaintSection'
import CheckboxController from '../../../../components/CheckboxSelector/CheckboxSelector'
import { alcohol_user, bloodSugarLevels, currentMedications, dietOpt, oralMedications, riskFactorExerciseOpt, smoker_user, smokerOpt, typeOfDiagnosis } from './formOptions'
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController'
import InputController, { InputControllerWithIcon } from '../../../../components/InputController/InputController'
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import DatePickerController from '../../../../components/CustomDatepicker/CustomDatePicker'
import { CustomInputLable, InputContainer, ParentContainerSection } from '../DiabeticForm'

const KnownPatients = (props) => {
    const {control, errors, watch} = props
    const current_medication_value= watch("current_medication")
  return (
   <>
     <ParentContainerSection  heading="Section D - Known patients with DM">

     <InputContainer>
          <CustomInputLable>Treatment Duration(years)</CustomInputLable>
          <InputController
             name="treatment_years"
            control={control}
            errors={errors}
            size="small"
            isSmall={true} 
            fullWidth={false}
            placeholder="Treatment Years"
            isDisabled
            isNumberField

          />
          <CustomInputLable>Diagnosis Date</CustomInputLable>
          <DatePickerController
            name="date_of_diagnosis"
            control={control}
            errors={errors}
            isDisabled
            size="small"
          />
        </InputContainer>

        <InputContainer>
          <CustomInputLable>Type</CustomInputLable>
          <RadioButtonController
            name="type_of_diagnosis"
            control={control}
            errors={errors}
            options={typeOfDiagnosis}
            isDisabled
            isRow
          />

        </InputContainer>

        <InputContainer>

          <CustomInputLable required>Currently on Medication</CustomInputLable>
          <RadioButtonController
            name="current_medication"
            control={control}
            errors={errors}
            options={currentMedications}
            isDisabled
            isRow
          />
        </InputContainer>

        {current_medication_value === "yes" && <InputContainer>
          <CustomInputLable>Medication Type</CustomInputLable>
          <CheckboxController
            name={"medication_oral_injection"}
            isRow={true}
            isMultiCheckbox={true}
            control={control}
            errors={errors}
            options={oralMedications}
            isHorizantalPadding={true}
            isCustomPadding
            isDisabled
            size="small"
          />
        </InputContainer>}

        <CustomInputLable >Blood Sugar Level</CustomInputLable>
        <InputContainer style={{  marginTop:"1rem" }}>
          <CustomInputLable  >RBS</CustomInputLable>
          <InputController
            name="blood_sugar_level.RBS"
            control={control}
            errors={errors}
            size="small"
            fullWidth={false}
            placeholder="RBS"
            isDisabled
            isSmall
          />
        </InputContainer>
        <InputContainer>
          <CustomInputLable >FBS</CustomInputLable>
          <InputController
            name="blood_sugar_level.FBS"
            control={control}
            errors={errors}
            size="small"
            fullWidth={false}
            placeholder="FBS"
            isDisabled
            isSmall
          />
        </InputContainer>
        <InputContainer>
          <CustomInputLable >HbA1c</CustomInputLable>
          <InputController
            name="blood_sugar_level.HbA1c"
            control={control}
            errors={errors}
            size="small"
            fullWidth={false}
            placeholder="HbA1c"
            isDisabled
            isSmall
          />
        </InputContainer>

        <InputContainer minWidth="144px"> 

          <CustomInputLable required>Blood Sugar Levels</CustomInputLable>
          <RadioButtonController
            name="blood_sugar_levels"
            control={control}
            errors={errors}
            options={bloodSugarLevels}
            isDisabled
            isRow
          />
        </InputContainer>

        <InputContainer minWidth="144px">

          <CustomInputLable required>Risk Factors Exercise</CustomInputLable>
          <RadioButtonController
            name="risk_factor_excercise"
            control={control}
            errors={errors}
            options={riskFactorExerciseOpt}
            isDisabled
            isRow
          />
        </InputContainer>

        <InputContainer>
          <CustomInputLable >Alcohol Use</CustomInputLable>
           <RadioButtonController
            name="alochol_use"
            control={control}
            errors={errors}
            options={alcohol_user}
            isDisabled
            isRow
          />
        </InputContainer>

        <InputContainer minWidth="144px">

          <CustomInputLable required >Diet</CustomInputLable>
          <RadioButtonController
            name="diet"
            control={control}
            errors={errors}
            options={dietOpt}
            isDisabled
            isRow
          />
        </InputContainer>
        <InputContainer>
          <CustomInputLable >Smoker</CustomInputLable>
            <RadioButtonController
            name="smoker"
            control={control}
            errors={errors}
            options={smoker_user}
            isDisabled
            isRow
          />
        </InputContainer>


            </ParentContainerSection>
   </>
  )
}

export default KnownPatients